import { ExpandMore, Schedule } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { isFuture } from 'date-fns';
import { typeIcons } from 'src/pages/Timeline/utils/Icons';
import { MetaResumoAssembleia } from 'src/types/convocation-summary';
import { formatDate } from 'src/utils/date';

import { getQuorumText } from '../utils';

const assembleiaTypes = [
  { value: 'AGE', label: 'Assembleia Extraordinária' },
  { value: 'AGO', label: 'Assembleia Ordinária' },
  { value: 'AGO/E', label: 'Assembleia Especial' },
];

export function MobileTimeline({ item }: { item: MetaResumoAssembleia }) {
  const handleButtonClick = (url: string) => {
    window.open(url, '_blank');
  };

  const { icon, color } =
    typeIcons(24)[item.categoriadocumento as keyof typeof typeIcons];

  return (
    <Card elevation={2} sx={{ width: '100%', mb: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
          <Box
            sx={{
              backgroundColor: color,
              borderRadius: '50%',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            {icon}
          </Box>
          <Box
            display="flex"
            alignItems="flex-start"
            gap={1}
            flexDirection="column">
            <Typography variant="h6" color="primary" fontWeight="bold">
              {formatDate(item.datareferencia)}
            </Typography>
            {item.datareferencia && isFuture(new Date(item.datareferencia)) && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <Schedule color="primary" fontSize="small" />
                <Typography
                  variant="body2"
                  fontSize={12}
                  color="text.secondary">
                  Evento futuro
                </Typography>
              </Box>
            )}
          </Box>
        </Stack>

        <Typography
          variant="body2"
          color="text.primary"
          textTransform="uppercase"
          fontWeight="bold"
          sx={{ fontSize: 12, mb: 2 }}>
          {assembleiaTypes.find((t) => t.value === item.tipodocumento)?.label ||
            item.categoriadocumento}
          {item.especiedocumento ? `- ${item.especiedocumento}` : ''}
        </Typography>

        <Stack spacing={1} mb={2}>
          {item.tipodocumento && (
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2" fontWeight="bold">
                Tipo:
              </Typography>
              <Chip
                label={item.tipodocumento}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Box>
          )}

          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" fontWeight="bold">
              Quorum:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {getQuorumText(item.quorum)}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" fontWeight="bold">
              Data:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatDate(item.datareferencia)}
            </Typography>
          </Box>
        </Stack>

        <Accordion
          elevation={0}
          sx={{ boxShadow: 'none', '&:before': { display: 'none' } }}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{
              px: 0,
              minHeight: 'auto',
              '& .MuiAccordionSummary-content': { margin: 0 },
            }}>
            <Typography variant="subtitle2" fontWeight="bold">
              Resumo
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              px: 0,
              pt: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}>
            <Typography variant="body2" color="text.secondary" textAlign="left">
              {item.resumo}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={(_) => handleButtonClick(item.url)}
              sx={{
                textTransform: 'uppercase',
                width: { xs: '100%', sm: '50%' },
                whiteSpace: 'nowrap',
              }}>
              Baixar Documento
            </Button>
          </AccordionDetails>
        </Accordion>
      </CardContent>
    </Card>
  );
}

export function YearSeparatorMobile({ year }: { year: number }) {
  return (
    <Box sx={{ my: 4, textAlign: 'center' }}>
      <Typography
        variant="h4"
        color="text.secondary"
        fontWeight="300"
        sx={{
          fontSize: { xs: '2rem', sm: '2.5rem' },
          opacity: 0.6,
        }}>
        {year}
      </Typography>
      <Divider sx={{ mt: 2, opacity: 0.3 }} />
    </Box>
  );
}
